<template>
  <v-card style="margin-bottom:1em" class="RelatorioNdMassivaEpocaFiltros">
    <v-form ref="form" autocomplete="off">
      <v-card-title>
        <div class="title">{{ $tc('title.detalhamento_nd_massiva_epoca', 1) }}</div>
        <v-spacer></v-spacer>
        <v-icon v-show="mostrarFiltros"
          @click="fixaFiltros"
          :class="filtrosFixosClass"
          style="margin-right: 10px"
          >fa-thumbtack</v-icon>
        <v-icon @click="toggleMostrarFiltros">filter_list</v-icon>
      </v-card-title>
      <v-container fluid grid-list-md v-show="mostrarFiltros">
        <metadados-container-layout
          v-if="camposFormulario !== null"
          :ordenacao-campos="ordenacaoCampos"
          :campos-formulario="camposFormulario"
          :explode-hierarquia="true"
          :formulario-filtros="true"
          :ignora-obrigatorios="true"
          :objeto="filtrosNdMassivaEpoca"
          ref="container">
          <v-col cols="12" sm="6" md="4" slot="antes">
            <v-menu
              ref="menuMesPesquisa"
              :close-on-content-click="false"
              v-model="menuMesPesquisa"
              id="mes_pesquisa"
              name="mes_pesquisa"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              :return-value.sync="mesPesquisa"
              max-width="290px"
              min-width="290px">
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-model="mesPesquisa"
                  multiple
                  chips
                  deletable-chips
                  clearable
                  :label="$t('label.periodo_vigencia')"
                  prepend-icon="event"
                  :rules="[required]"
                  v-on="on"
                ></v-combobox>
              </template>
              <v-date-picker locale="pt-br" color="primary" type="month" multiple v-model="mesPesquisa">
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menuMesPesquisa = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menuMesPesquisa.save(mesPesquisa)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </metadados-container-layout>
      </v-container>
      <v-card-actions v-show="mostrarFiltros">
        <v-spacer></v-spacer>
        <v-btn @click="resetaFiltros"
          color="accent"
        >{{$t('label.limpar_filtros')}}</v-btn>
        <v-btn @click="aplicarFiltros"
          color="primary"
        >{{$t('label.exportar')}}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>

import { skipLoading } from '@/common/functions/loading';
import { mapGetters } from 'vuex';
import { countRelatorioNdMassivaEpoca } from '@/common/resources/magalu-relatorios'; // eslint-disable-line
import MetadadosContainerLayout from '@/shared-components/metadados/MetadadosContainerLayout';
import MetadadosCampoDinamicoData from '@/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoData';
import RelatorioNdMassivaEpocaFiltrosCampos from './RelatorioNdMassivaEpocaFiltrosCampos';

export default {
  name: 'RelatorioNdMassivaEpoca',
  mixins: [
    RelatorioNdMassivaEpocaFiltrosCampos,
  ],
  watch: {
    filtrosNdMassivaEpoca: {
      handler() {
        this.umFiltroObrigatorioSelecionado = false;
        if (this.mesPesquisa && this.mesPesquisa.length) {
          this.umFiltroObrigatorioSelecionado = true;
        }

        Object.values(this.filtrosNdMassivaEpoca).every((value) => {
          if (value instanceof Array) {
            if (value && value.length) {
              this.umFiltroObrigatorioSelecionado = true;
              return false;
            }
          } else if (value) {
            this.umFiltroObrigatorioSelecionado = true;
            return false;
          }
          return true;
        });
        this.$refs.form.resetValidation();
      },
      deep: true,
    },
  },
  computed: {
    filtrosFixosClass() {
      return {
        'primary--text': this.filtrosFixados,
        'mr-2': true,
      };
    },
    ...mapGetters('implantacao', [
      'chaveEmpresa',
    ]),
    isAmbienteEpoca() {
      return this.chaveEmpresa === 'EPOCA';
    },
  },
  components: {
    MetadadosContainerLayout,
    MetadadosCampoDinamicoData,
  },
  data() {
    return {
      ordenacaoCampos: [
        'grupo_fornecedor',
        'tipo_acao',
      ],
      mostrarFiltros: false,
      filtrosFixados: false,
      filtrosNdMassivaEpoca: {},
      umFiltroObrigatorioSelecionado: true,
      limiteRegistrosExportacao: 50000,
      menuMesPesquisa: false,
      mesAnoAtual: this.moment().format('YYYY-MM'),
      mesPesquisa: [],
      mesesAnosString: [],
      camposFormulario: null,
    };
  },
  methods: {
    required(value) {
      if (value instanceof Array && value.length === 0) {
        return this.$t('message.campo_obrigatorio');
      }
      return !!value || this.$t('message.campo_obrigatorio');
    },
    toggleMostrarFiltros() {
      this.mostrarFiltros = !this.mostrarFiltros;
    },
    filtroValido() {
      // valida se algum filtro foi selecionado
      return this.umFiltroObrigatorioSelecionado;
    },
    resetaFiltros() {
      this.filtrosNdMassivaEpoca = {};
      this.mesPesquisa = [this.mesAnoAtual];
    },
    aplicarFiltros() {
      this.mesesAnosString = [];
      const filtrosAplicados = this.$refs.container.getValoresCamposPadrao();

      if (!this.$refs.form.validate()) {
        return;
      }
      if (!this.filtroValido()) {
        this.$toast(this.$t('message.selecione_um_filtro_obrigatorio'));
        return;
      }
      if (filtrosAplicados.origem !== null && typeof filtrosAplicados.origem !== 'undefined') {
        filtrosAplicados.acao = true;
      }

      this.mesPesquisa.forEach((anoMes) => {
        this.mesesAnosString.push(parseInt(anoMes.replaceAll('-', ''), 10));
      });

      const mesesAnos = this.mesesAnosString;

      const params = {
        ...filtrosAplicados,
        mesesAnos,
        meses_anos: mesesAnos,
        min_mes: Math.min(...mesesAnos),
        max_mes: Math.max(...mesesAnos),
      };

      let quantidadeRegistros = 0;

      countRelatorioNdMassivaEpoca(params, this.$resource)
        .then((response) => {
          quantidadeRegistros = response.data;
          if (quantidadeRegistros > this.limiteRegistrosExportacao) {
            this.$toast(this.$t('errors.registros.excede_limite_dados', { limite: this.limiteRegistrosExportacao }));
          } else if (quantidadeRegistros > 0) {
            let nomeRelatorio = '';
            if (this.isAmbienteEpoca) {
              nomeRelatorio = 'nd_massiva_epoca';
            }
            this.$emit('RelatorioExportacaoNdMassivaEpoca__AplicaFiltros',
              params,
              nomeRelatorio,
              'api');
          } else {
            this.$toast(this.$t('errors.registros.nao_ha_dados'));
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    fixaFiltros() {
      this.filtrosFixados = !this.filtrosFixados;
      this.workspace.indAberto = this.filtrosFixados;
      if (!this.workspace.id) {
        this.inserirWorkspace();
      } else {
        this.atualizarWorkspace();
      }
    },
    inserirWorkspace() {
      skipLoading();
      const entidade = 'relatorio-nd-massiva-epoca';
      this.workspaceFiltrosResources.inserir({ entidade }, this.workspace)
        .then((response) => {
          this.workspace.id = response.data;
        }).catch((err) => {
          this.$error(this, err);
        });
    },
    atualizarWorkspace() {
      skipLoading();
      const entidade = 'relatorio-nd-massiva-epoca';
      this.workspaceFiltrosResources.atualizar({ entidade }, this.workspace)
        .then()
        .catch((err) => {
          this.$error(this, err);
        });
    },
    salvarFiltrosWorkspace() {
      this.workspace.filtros = this.filtrosNdMassivaEpoca;
      if (!this.workspace.id) {
        this.inserirWorkspace();
      } else {
        this.atualizarWorkspace();
      }
    },
  },
  mounted() {
    this.mesPesquisa.push(this.mesAnoAtual);
    if (this.isAmbienteEpoca) {
      this.camposFormulario = this.camposFormularioEpoca;
    }
  },
};
</script>
<style>
  .RelatorioNdMassivaEpoca__Opcoes {
    padding: 0 0 0 20px;
    margin-top: 0;
  }
  .RelatorioNdMassivaEpoca__Opcoes div.v-input__slot,
  .RelatorioNdMassivaEpoca__Opcoes div.v-radio {
    margin-bottom: 0;
  }
  .RelatorioNdMassivaEpoca__Opcoes div.v-messages {
    display: none;
  }
  .RelatorioNdMassivaEpoca__Opcoes label {
    font-size: 14px;
  }
</style>
